import {ApiClientError} from '@/api/client';
import {Link, useParams, useSearchParams} from 'react-router-dom';
import {getSSOLink, getSite} from '@/api/sites';
import {useEffect, useState} from 'react';

function getAdminPath(value: string | null): string | undefined {
    if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\') || value.includes('#') || /[\u0000-\u001f]/.test(value)) {
        return undefined;
    }

    return value;
}

export function OpenSitePage() {
    const {id} = useParams<{id: string}>();
    const [searchParams] = useSearchParams();
    const hasSsoError = searchParams.has('error');
    const [attempt, setAttempt] = useState(0);
    const [error, setError] = useState<string | null>(hasSsoError ? 'We could not sign you in to this publication. Please try again.' : null);
    const returnTo = getAdminPath(searchParams.get('returnTo'));

    useEffect(() => {
        if (!id || (hasSsoError && attempt === 0)) {
            return;
        }

        let cancelled = false;
        setError(null);

        async function open(siteId: string) {
            try {
                const site = await getSite(siteId);
                if (site.status !== 'active') {
                    throw new Error('This publication is not ready to open.');
                }

                const url = await getSSOLink(siteId, returnTo);
                if (!cancelled) {
                    window.location.replace(url);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err instanceof ApiClientError && err.status === 403
                        ? 'You do not have access to this publication.'
                        : err instanceof Error && !(err instanceof ApiClientError)
                            ? err.message
                            : 'We could not open this publication. Please try again.');
                }
            }
        }

        open(id);
        return () => {
            cancelled = true;
        };
    }, [id, returnTo, attempt, hasSsoError]);

    return (
        <main className="studio-main" id="main-content">
            <div className="studio-main-inner" style={{maxWidth: 520, paddingTop: 80, textAlign: 'center'}}>
                <h1 className="studio-page-title">Opening your publication</h1>
                {error ? <>
                    <p role="alert">{error}</p>
                    <button className="studio-control studio-control-primary" type="button" onClick={() => setAttempt(value => value + 1)}>Try again</button>
                    <p><Link to="/dashboard">Back to publications</Link></p>
                </> : <p>Signing you in securely…</p>}
            </div>
        </main>
    );
}
